import { Formik, FormikHelpers } from 'formik'
import FormikFormattedTextField from '@ui-components-3/compat/lib/components/FormikFormattedTextField'
import TestIds from 'util/TestIds'
import AccessCodeSchema from 'schemas/AccessCodeSchema'
import useDocumentTitle from 'hooks/useDocumentTitle'
import EntryFormCard from '../EntryFormCard'
import { CodeValues } from 'pages/EntryPage/EntryPage'
import { accessCodeInputFormat, cleanAccessCodeInput } from 'util/formatters'

type AccessCodeProps = {
  email: string | null
  onSubmit: (values: CodeValues, form: FormikHelpers<CodeValues>) => void
  onBack: () => void
}

const AccessCodeScene = (props: AccessCodeProps): JSX.Element => {
  useDocumentTitle('Login Access code')

  return (
    <EntryFormCard prompt={'Enter your access code'} data-testid={TestIds.login.view.accessCode}>
      <p className="typography-body pb-4 text-start text-neutral-600">All fields marked with asterisks are required*</p>
      <Formik initialValues={{ code: '' }} validationSchema={AccessCodeSchema} onSubmit={props.onSubmit}>
        {(renderProps) => {
          const { dirty, isValid, handleSubmit } = renderProps
          return (
            <form
              onSubmit={handleSubmit}
              className="flex flex-col items-center"
              data-testid={TestIds.login.form.accessCode}
            >
              <div data-testid={TestIds.login.input.code} className="mb-9 w-full">
                <FormikFormattedTextField
                  fullWidth
                  label={'Access Code'}
                  schema={AccessCodeSchema}
                  name={'code'}
                  unformatText={cleanAccessCodeInput}
                  formatText={accessCodeInputFormat}
                  className="[&_input]:text-center"
                />
              </div>
              <div className="mb-2 flex w-full items-center justify-between gap-4">
                <button
                  className="btn btn-primary-outlined grow"
                  data-testid={TestIds.login.button.cancel}
                  onClick={props.onBack}
                  type="button"
                >
                  Back
                </button>
                <button
                  className="btn btn-primary grow"
                  data-testid={TestIds.login.button.verifyCode}
                  disabled={!dirty || !isValid}
                  type="submit"
                >
                  Continue
                </button>
              </div>
            </form>
          )
        }}
      </Formik>
    </EntryFormCard>
  )
}

export default AccessCodeScene
